import { IForm } from 'core-components/classes/models/IForm'
import { IColumn } from 'core-components/library/list/types'
import { Logic } from 'core-components/types'
import { Static } from 'core-components/types'
import { IFilter } from 'core-components/types'
import { Crud } from 'core/types/Crud'

export const INITIAL_CRUD = new Crud({
  fetcher: new Static([] as IForm[]),
  keyField: 'EntryId',
})

export const KEY_CONTACT_ROLES = [
  'Partner Signer',
  'HP Champion',
  'L&R Champion',
  'Data Collection Contact',
]

export const MNGR_ROLES = ['AOM', 'RAM', 'PBM', 'SuperAdmin']

export const GENERAL_COLUMNS: IColumn[] = [
  { field: 'ContactID', title: 'Contact ID', priority: 1 },
  { field: 'LearnerID', title: 'Learner ID', priority: 2 },
  { field: 'FirstName', title: 'First Name', priority: 3 },
  { field: 'LastName', title: 'Last Name', priority: 4 },
  {
    field: 'PR_HP_ROLE',
    title: 'Hp Roles',
    priority: 5,
  },
  {
    field: 'UserStatus',
    title: 'User Status',
    priority: 6,
  },
  {
    field: 'WorkPhone',
    title: 'Work Phone',
    priority: 7,
  },
  {
    field: 'MobilePhone',
    title: 'Mobile Phone',
    priority: 8,
  },
  { field: 'Email', title: 'Email', priority: 9 },
  {
    field: 'LocationID',
    title: 'Location ID',
    priority: 10,
  },
  {
    field: 'NeverCall',
    title: 'Never Call',
    priority: 11,
  },
  {
    field: 'NeverEmail',
    title: 'Never Email',
    priority: 12,
  },
  {
    field: 'PartnerID',
    title: 'Partner ID',
    priority: 13,
  },
  {
    field: 'CommunicationName',
    title: 'Comm. Name',
    priority: 14,
  },
  { field: 'City', title: 'City', priority: 15 },
  {
    field: 'PrimaryPartner',
    title: 'Primary',
    priority: 16,
  },
]

export const NEW_CONTACT_COLUMNS: IColumn[] = [
  { field: 'CreatedBy', title: 'Created By', priority: 17 },
  { field: 'Created', title: 'Created', priority: 18 },
]

export const EXISTED_CONTACT_COLUMNS: IColumn[] = [
  {
    field: 'TopPartnerID',
    title: 'TopPartnerID',
    priority: 17,
  },
  { field: 'ModifiedBy', title: 'Modified By', priority: 18 },
  { field: 'Modified', title: 'Modified', priority: 19 },
]

export const PROFILING_TEAM_COLUMNS = [
  { field: 'WorkflowStatus', title: 'Workflow status', priority: 5 },
  {
    field: 'ProfileTeamComment',
    title: 'Profile team comment',
    priority: 6,
  },
  { field: 'Market', title: 'Market', priority: 8 },
]

export const TABS_CONFIG = {
  allContacts: {
    id: 'allContacts',
    label: 'All Contacts',
    columns: GENERAL_COLUMNS,
  },
  profilingTeamRequests: {
    id: 'profilingTeamRequests',
    label: 'Profiling Team Requests',
    columns: [...GENERAL_COLUMNS, ...EXISTED_CONTACT_COLUMNS, ...PROFILING_TEAM_COLUMNS],
  },
  newContacts: {
    id: 'newContacts',
    label: 'New Contacts',
    columns: [...GENERAL_COLUMNS, ...NEW_CONTACT_COLUMNS],
  },
}

export const PAGE_CONFIG = {
  page: 0,
  pageSize: 10,
}

export const INITIAL_CONJUNCTION_FILTER = { logic: Logic.AND, filters: [] as IFilter[] }
export const INITIAL_DISJUNCTION_FILTER = { logic: Logic.OR, filters: [] as IFilter[] }
